module.exports = __webpack_public_path__ + "img/water-droplet-5.c66ec6fa.png";